/* @flow strict */

import * as React from 'react';
import './eventDetail.scss';
import moment from 'moment';
type PropsType = {
  eventDetail: {
    name: string,
    location: string,
    begin_time_utc: dateFormat,
    end_time_utc: dateFormat
  }
};
const EventDetail = (props: PropsType): React.Element<'div'> => {
  const { eventDetail } = props;

  return (
    <div className="sparxo-checkout-EventDetail_container">
      <div className="sparxo-checkout-EventDetail_event_info">
        <div className="sparxo-checkout-EventDetail_event_date_wrapper">
          <div className="sparxo-checkout-EventDetail_event_month">
            {eventDetail ? moment(eventDetail.begin_time_utc).format('MMM') : ''}
          </div>
          <div className="sparxo-checkout-EventDetail_event_date">{eventDetail ? moment(eventDetail.begin_time_utc).format('DD') : ''}</div>
        </div>
        <div className="sparxo-checkout-EventDetail_event_desc">
          <div className="sparxo-checkout-EventDetail_event_name">{eventDetail.name}</div>
          <div className="sparxo-checkout-EventDetail_event_adress">
            {eventDetail.location}
          </div>
          {/* <div className="sparxo-checkout-EventDetail_event_time">April 10, 10:00pm - April 10, 11:00pm</div> */}
          <div className="sparxo-checkout-EventDetail_event_time">
              {eventDetail ? moment(eventDetail.begin_time_utc).format('MMMM DD h:mm a') : ''}
            <span> - </span>
            {eventDetail ? moment(eventDetail.end_time_utc).format('MMMM DD h:mm a') : ''}
          </div>

        </div>
      </div>
    </div>
  );
};

export default EventDetail;
